import * as UserEvents from 'src/utils/user/event';
import { Nullable } from 'src/types/nullable.type';

export const embedUserEventsFactory = (params: {
  aliasUUID: string;
  trackingUUID: string;
  sessionUUID: string;
  email: Nullable<string>;
}) => ({
  createUserViewEvent: (contentID: string) => new UserEvents.View({ ...params, contentID }),
  createDocumentPageViewEvent: (contentID: string) => new UserEvents.DocumentPageView({ ...params, contentID }),
  createCalendarSubmissionEvent: (contentID: string) => new UserEvents.CalendarSubmission({ ...params, contentID }),
  createJourneyViewEvent: () => new UserEvents.JourneyView(params),
  createEmailCaptureEvent: (email: string) => new UserEvents.EmailCapture({ ...params, email }),
  createVideoPlayEvent: (contentID: string) => new UserEvents.VideoPlay({ ...params, contentID }),
  createVideoEndEvent: (contentID: string) => new UserEvents.VideoEnded({ ...params, contentID }),
  createReactionEvent: (contentID: string) => new UserEvents.Reaction({ ...params, contentID }),
  createCommentEvent: (contentID: string, email: string) => new UserEvents.Comment({ ...params, contentID, email }),
  createExternalLinkVisitEvent: (contentID: string) => new UserEvents.LinkVisit({ ...params, contentID }),
});
